/** Route guard: renders its children only when signed in; otherwise redirects to the landing page. */

import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'
import { useAuth } from './AuthContext'

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return null
  if (!user) return <Navigate to="/" replace state={{ from: location.pathname }} />
  return <>{children}</>
}

/**
 * Route guard: renders its children only once the signed-in user has a
 * completed profile; otherwise redirects to `/onboarding`. Nest this inside
 * `RequireAuth` (never wrap `/onboarding` itself in it — see `router.tsx`,
 * that would redirect-loop the exact users this guard targets).
 */
export function RequireOnboarded({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) return null
  if (user && !user.profile_complete) return <Navigate to="/onboarding" replace />
  return <>{children}</>
}
